import React           from 'react';

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return( 
            <ul ref="CONTAINER">
                { p.children  }
            </ul>    
        )
    }
}

export default List;